<template>
  <div :class="style['slider-img-container']">
    <img :class="[style.img]" :src="checkSlideMediaContent" alt="images" />
    <poweredby-icon v-if="slide.powered_by" :icon="slide.powered_by" />
    <label :class="style['room-label']">{{ slide.available_room_label }}</label>
  </div>
</template>

<script>
import style from './scss/_slider_image.scss'
import { placeholderImage } from 'javascript/Constants'
import PoweredbyIcon from 'UtilityComponents/PoweredbyIcon.vue'

export default {
  components: {
    PoweredbyIcon
  },
  props: {
    slide: {
      type: Object,
      required: true
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    showPriceTag: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style: () => style,
    checkSlideMediaContent() {
      return this.slide.media_content || placeholderImage
    }
  }
}
</script>
